import axios, {AxiosRequestConfig} from 'axios';
import {ApiPath, PageName} from '@/common/core/common';

export class AdapterBase {

  // @ts-ignore
  protected axiosRequestConfig: AxiosRequestConfig;

  /**
   * サーバサイドへのリクエストを行う。
   *
   * @param method
   * @param url
   * @param params
   */
  protected request<T>(method: string, url: string, json: boolean, params: any): Promise<T> {
    return new Promise((resolve, reject) => {
      if (json) {
        let accessToken = '';
        let client = '';
        let uid = '';
        let cookie = document.cookie;
        let cookies = cookie.split(';');
        for (let c of cookies) {
          c = c.trim();
          let cArray = c.split('=');
          if (cArray[0] === 'access-token') {
            accessToken = cArray[1];
            continue;
          }
          if (cArray[0] === 'client') {
            client = cArray[1];
            continue;
          }
          if (cArray[0] === 'uid') {
            uid = cArray[1];
          }
        }
        this.axiosRequestConfig = {
          headers: {
            Accept: 'application/json',
            'access-token': accessToken,
            client: client,
            uid: uid
          },
          withCredentials: true,
          method,
          url: ApiPath.BASE_URL + url,
          data: {},
        };
      } else {
        this.axiosRequestConfig = {
          method,
          url: ApiPath.BASE_URL + url,
        };
      }
      if (method === 'GET' || method === 'DELETE') {
        this.axiosRequestConfig.params = params;
      } else {
        this.axiosRequestConfig.data = params;
        this.axiosRequestConfig.withCredentials = true;
      }
      axios(this.axiosRequestConfig).then((res) => {
        if (url === ApiPath.LOGIN_URI) {
          // 認証情報をクッキーへ保存
          let maxAge = 60 * 30; // Cookieの有効期限は秒で指定する
          document.cookie = 'access-token=' + res.headers['access-token'] + ';max-age=' + maxAge.toString() + ';';
          document.cookie = 'client=' + res.headers['client'] + ';max-age=' + maxAge.toString() + ';';
          document.cookie = 'uid=' + res.headers['uid'] + ';max-age=' + maxAge.toString() + ';';
        }
        if (url === ApiPath.LOGOUT_URI) {
          // 認証情報をクッキーから削除
          let cookie = document.cookie;
          let cookies = cookie.split(';');
          for (let c of cookies) {
            let cArray = c.split('=');
            document.cookie = cArray[0] + '=;max-age=0'
          }
          // ローカルストレージの削除
          localStorage.clear();
        }
        resolve(res.data);
      }).catch((err) => {
        reject(err.response ? err.response.data : err);
      });
    });

  }
}
